import { WppTypography } from '@wppopen/components-library-react'
import { HeaderData } from './TaskMetadataHeader.d'
import styles from './TaskMetadataHeader.module.scss'
import AsyncTypography from 'components/AsyncTypography/AsyncTypography'
import clsx from 'clsx'

interface TaskMetadataHeaderProps {
  headerData: HeaderData[]
  isInitialising?: boolean
}
function TaskMetadataHeader({ headerData, isInitialising }: TaskMetadataHeaderProps) {
  return (
    <div className={styles.metaContainer} data-testid="task-metadata-header">
      {headerData.map(({ field, title, value }) => {
        return (
          <div key={field} className={styles.metaContainer__cell} data-testid="header-field">
            <WppTypography
              type="xs-body"
              data-testid={title.toLocaleLowerCase().replaceAll(' ', '-')}
              className={clsx(styles.minWidthField)}
            >
              {title}:
            </WppTypography>
            <AsyncTypography
              type="xs-strong"
              dataTestId={`${title.toLocaleLowerCase().replaceAll(' ', '-')}-value`}
              tag="p"
              isLoading={isInitialising}
            >
              {value}
            </AsyncTypography>
          </div>
        )
      })}
    </div>
  )
}

export default TaskMetadataHeader
